import { useQuery } from 'react-query'

import { cardRepository } from '@webapp/modules/spending-cards/data-access/repositories/CardRepository'
import { Card } from '@webapp/modules/spending-cards/entities/Card'
import { cardQueryConfig } from '@webapp/modules/spending-cards/query-configs/card'

type UseQueryMyPhysicalCardReturn = {
  card: Nullable<Card>
  isLoading: boolean
  isFetching: boolean
  isFetched: boolean
}

export const useQueryMyPhysicalCard = ({
  enabled = false,
  onError,
}: {
  enabled: boolean
  onError?: (error: Error) => void
}): UseQueryMyPhysicalCardReturn => {
  const { data, isLoading, isFetched, isFetching } = useQuery({
    queryKey: cardQueryConfig.myPhysicalCard().queryKey,
    queryFn: () => cardRepository.getMyPhysicalCard(),
    enabled,
    onError,
  })

  return {
    card: data?.data ? new Card(data.data) : null,
    isLoading,
    isFetching,
    isFetched,
  }
}
